/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LinkSocialAccountRequestModel } from '../../models/link-social-account-request-model';
import { SocialAccountModel } from '../../models/social-account-model';

export interface LocalAccountLinkAccountPost$Params {
  
    /**
     * Link social account request model containing link token and source user details
     */
    body?: LinkSocialAccountRequestModel
}

export function localAccountLinkAccountPost(http: HttpClient, rootUrl: string, params?: LocalAccountLinkAccountPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<Array<SocialAccountModel>>> {
  const rb = new RequestBuilder(rootUrl, localAccountLinkAccountPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<Array<SocialAccountModel>>;
    })
  );
}

localAccountLinkAccountPost.PATH = '/LocalAccount/LinkAccount';
